/* facets-always-open.js
   PC 幅のとき .facets-container 内の details を常時 open にするスクリプト
   ※ Shopify 標準 global.js のハンドラとは独立して動作
   ※ モバイルの新しいフィルターUIも制御
*/
(() => {
    /* ブレークポイントを 1025px と定義（テーマの large-up 相当） */
    const MQ_DESKTOP = window.matchMedia('(min-width: 751px)');
  
    /* メイン処理：PC 幅だけ details を開き、スマホでは閉じておく */
    function toggleDetailsOpen() {
      document
        .querySelectorAll('.facets-container details')
        .forEach((detail) => {
          const summary = detail.querySelector('summary');
          if (!summary) return;

          if (MQ_DESKTOP.matches) {
            /* PC では常に開いた状態に固定 */
            detail.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');

            /* 2 回以上 addEventListener しないようにガード */
            if (!summary.dataset.alwaysOpenBound) {
              const handler = (e) => {
                /* 標準の toggle を無効化 */
                e.preventDefault();
                e.stopImmediatePropagation(); // global.js の click ハンドラも止める
              };
              summary.addEventListener('click', handler, true /* capture フェーズで先に止める */);
              summary.dataset.alwaysOpenBound = '1';
            }
          } else {
            /* スマホ幅では開かないようにし、aria 属性も戻す */
            detail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        });
    }
  
    /* DOM が組み上がったら一度実行 */
    document.addEventListener('DOMContentLoaded', toggleDetailsOpen);
  
    /* 画面幅が変わったら再評価 */
    MQ_DESKTOP.addEventListener('change', toggleDetailsOpen);

    /* ========== 新しいモバイルフィルターUI制御 ========== */
    document.addEventListener('DOMContentLoaded', () => {
      // モバイル幅（750px以下）の判定
      const MQ_MOBILE = window.matchMedia('(max-width: 750px)');
      
      if (!MQ_MOBILE.matches && !document.querySelector('.fc-browse, .fr-grid')) return;

      const overlay = document.querySelector('[data-facets-overlay]');
      const filterButton = document.querySelector('[data-facets-open="filter"]');
      const sortButton = document.querySelector('[data-facets-open="sort"]');
      const filterDrawer = document.querySelector('[data-facets-drawer="filter"]');
      const sortDrawer = document.querySelector('[data-facets-drawer="sort"]');
      const closeButtons = document.querySelectorAll('[data-facets-close]');
      const applyButton = document.querySelector('[data-facets-apply]');
      const sortOptions = document.querySelectorAll('[data-facets-sort-option]');

      // フォーム送信時にURLパラメータをマージする処理
      const mergeUrlParams = (formData, options = {}) => {
        // 現在のURLパラメータを取得
        const currentParams = new URLSearchParams(window.location.search);
        
        // マージ用のパラメータオブジェクト
        const mergedParams = new URLSearchParams();
        
        // オプションのデフォルト値
        const { isFilterOperation = false } = options;
        
        // 現在のパラメータをコピー
        for (const [key, value] of currentParams) {
          let shouldKeep = true;
          
          // ページネーション関連のパラメータは常に除外
          if (key.startsWith('page')) {
            shouldKeep = false;
          }
          // フィルター操作の場合のみ、フィルターパラメータを除外（完全置換のため）
          else if (isFilterOperation && key.startsWith('filter.')) {
            shouldKeep = false;
          }
          
          if (shouldKeep) {
            mergedParams.append(key, value);
          }
        }
        
        // 新しいフォームデータを追加（複数値対応）
        for (const [key, value] of formData.entries()) {
          if (value && value.trim() !== '') { // 空でない値のみ設定
            // console.log('Adding param:', key, '=', value); // デバッグ用（本番では非表示）
            
            // sort_byパラメータの場合は既存のものを削除してから追加
            if (key === 'sort_by') {
              mergedParams.delete(key);
            }
            
            mergedParams.append(key, value);
          }
        }
        
        // console.log('Final URL params:', mergedParams.toString()); // デバッグ用（本番では非表示）
        return mergedParams;
      };

      // ドロワーを開く処理
      function openDrawer(drawer) {
        if (!drawer || !overlay) return;
        
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // スクロール無効化
      }

      // ドロワーを閉じる処理
      function closeDrawer() {
        const activeDrawer = document.querySelector('.mobile-facets-drawer.active');
        
        if (activeDrawer) {
          activeDrawer.classList.remove('active');
        }
        if (overlay) {
          overlay.classList.remove('active');
        }
        document.body.style.overflow = ''; // スクロール復活
      }

      // フィルターボタンクリック
      if (filterButton && filterDrawer) {
        filterButton.addEventListener('click', () => {
          openDrawer(filterDrawer);
        });
      }

      // 並べ替えボタンクリック
      if (sortButton && sortDrawer) {
        sortButton.addEventListener('click', () => {
          openDrawer(sortDrawer);
        });
      }

      // 閉じるボタンクリック
      closeButtons.forEach(button => {
        button.addEventListener('click', closeDrawer);
      });

      // オーバーレイクリック（単純にドロワーを閉じるのみ）
      if (overlay) {
        overlay.addEventListener('click', () => {
          // オーバーレイクリック時は単純に閉じるだけ（自動送信を無効化）
          closeDrawer();
        });
      }

      // 適用ボタンクリック（フィルター用）
      if (applyButton) {
        applyButton.addEventListener('click', () => {
          // フォームを手動で送信（フィルター操作として処理）
          const form = applyButton.closest('form');
          if (form) {
            const formData = new FormData(form);
            const mergedParams = mergeUrlParams(formData, { isFilterOperation: true });
            const url = `${window.location.pathname}?${mergedParams}`;
            window.location.href = url;
          }
          closeDrawer();
        });
      }

      // 並べ替えオプション選択時の自動送信
      sortOptions.forEach(option => {
        option.addEventListener('change', (e) => {
          if (e.target.checked) {
            // フォームを手動で送信（mergeUrlParamsを使用）
            const form = e.target.closest('form');
            if (form) {
              const formData = new FormData(form);
              const mergedParams = mergeUrlParams(formData);
              const url = `${window.location.pathname}?${mergedParams}`;
              window.location.href = url;
            }
            closeDrawer();
          }
        });
      });

      // facet-filters-form のカスタム要素を初期化（既存の処理を流用）
      const initFacetForm = () => {
        const facetForms = document.querySelectorAll('facet-filters-form');
        facetForms.forEach(form => {
          // Shopifyの標準的なfacetフォーム処理に合わせる
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            // フィルターフォームの送信として処理
            const mergedParams = mergeUrlParams(formData, { isFilterOperation: true });
            const url = `${window.location.pathname}?${mergedParams}`;
            
            // ページ遷移
            window.location.href = url;
          });
        });
      };

      // facet-remove のカスタム要素を初期化
      const initFacetRemove = () => {
        const removeButtons = document.querySelectorAll('facet-remove a');
        removeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            
            // .mobile-facets-drawer__clear-link の特別処理
            if (button.classList.contains('mobile-facets-drawer__clear-link')) {
              clearCurrentDrawerFilters();
              return; // ページ遷移せずに終了
            }
            
            // 他の facet-remove リンクは従来通りページ遷移
            const url = e.currentTarget.href;
            window.location.href = url;
          });
        });
      };

      // 現在のドロワー内のフィルターをクリアする処理
      const clearCurrentDrawerFilters = () => {
        // アクティブなドロワーを取得
        const activeDrawer = document.querySelector('.mobile-facets-drawer.active');
        if (!activeDrawer) return;
        
        // ドロワー内のすべてのチェックボックスを取得
        const checkboxes = activeDrawer.querySelectorAll('.mobile-facets-checkbox input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
          const label = checkbox.closest('.mobile-facets-checkbox');
          
          // チェックを外す
          checkbox.checked = false;
          
          // activeクラスを削除
          if (label) {
            label.classList.remove('active');
          }
        });
        
        // 価格範囲入力もクリア
        const priceInputs = activeDrawer.querySelectorAll('.mobile-facets-price input[type="number"]');
        priceInputs.forEach(input => {
          input.value = '';
        });
      };

      // カスタム要素の初期化
      initFacetForm();
      initFacetRemove();

      // チェックボックスの即時反応
      const initCheckboxInteraction = () => {
        const checkboxes = document.querySelectorAll('.mobile-facets-checkbox input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
          const label = checkbox.closest('.mobile-facets-checkbox');
          
          // 初期状態の設定（ページ読み込み時のチェック状態に合わせる）
          if (checkbox.checked) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
          
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              label.classList.add('active');
            } else {
              label.classList.remove('active');
            }
          });
        });
      };

      // ラジオボタンの即時反応（並べ替え用）
      const initRadioInteraction = () => {
        const radios = document.querySelectorAll('.mobile-facets-sort-label input[type="radio"]');
        
        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            // すべてのラベルからactiveクラスを削除
            document.querySelectorAll('.mobile-facets-sort-label').forEach(label => {
              label.classList.remove('active');
            });
            
            // 選択されたラベルにactiveクラスを追加
            if (radio.checked) {
              radio.closest('.mobile-facets-sort-label').classList.add('active');
            }
          });
        });
      };

      // 初期化
      initCheckboxInteraction();
      initRadioInteraction();
      

    });

    document.addEventListener('DOMContentLoaded', initStickyButtons);


    function initCollectionControls(buttons) {
      const root = buttons.closest('.fc-browse');
      const chips = root.querySelector('.mobile-facets-chips-wrapper');
      const header = document.querySelector('.header-wrapper');
      const mobile = matchMedia('(max-width:989px)');
      const chipHome = document.createComment('selected conditions home');
      chips.before(chipHome);
      const slot = document.createElement('div');
      slot.className = 'mobile-facets-sticky-slot';
      const controls = document.createElement('div');
      controls.className = 'fitau-filter-controls';
      buttons.before(slot);
      slot.append(controls);
      controls.append(buttons);
      let frame = 0;
      function update() {
        frame = 0;
        if (!mobile.matches) return;
        const rect = slot.getBoundingClientRect();
        const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const fixed = rect.top <= top;
        if (fixed) {
          controls.style.top = top + 'px';
          controls.style.left = rect.left + 'px';
          controls.style.width = rect.width + 'px';
        } else {
          controls.style.cssText = '';
        }
        controls.classList.toggle('is-sticky', fixed);
        slot.style.height = fixed ? controls.getBoundingClientRect().height + 'px' : '';
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(update); }
      function layout() {
        controls.classList.remove('is-sticky');
        controls.style.cssText = '';
        slot.style.height = '';
        if (mobile.matches) controls.append(chips);
        else chipHome.after(chips);
        schedule();
      }
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule);
      window.addEventListener('pageshow', schedule);
      mobile.addEventListener('change', layout);
      const observer = new ResizeObserver(schedule);
      observer.observe(controls);
      if (header) observer.observe(header);
      layout();
    }

    function initStickyButtons() {
      const buttons = document.querySelector('.mobile-facets-buttons');
      if (!buttons || buttons.parentElement.classList.contains('mobile-facets-sticky-slot')) return;
      if (document.querySelector('.fc-browse')) {
        initCollectionControls(buttons);
        return;
      }
      const mobile = window.matchMedia('(max-width: 750px)');
      const header = document.querySelector('.header-wrapper');
      const slot = document.createElement('div');
      slot.className = 'mobile-facets-sticky-slot';
      slot.style.display = 'flow-root';
      buttons.before(slot);
      slot.append(buttons);
      buttons.style.transition = 'none';
      let height = 0;
      let frame = 0;

      function reset() {
        buttons.classList.remove('mobile-facets-buttons--sticky');
        ['top', 'left', 'right', 'width', 'height', 'box-sizing'].forEach(name => buttons.style.removeProperty(name));
        slot.style.removeProperty('height');
      }

      function measure() {
        reset();
        if (mobile.matches || document.querySelector('.fc-browse, .fr-grid')) {
          height = buttons.getBoundingClientRect().height;
          slot.style.height = slot.getBoundingClientRect().height + 'px';
        }
        update();
      }

      function update() {
        frame = 0;
        if (!mobile.matches && !document.querySelector('.fc-browse, .fr-grid')) {
          reset();
          return;
        }
        const rect = slot.getBoundingClientRect();
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const sticky = rect.top <= headerBottom;
        buttons.classList.toggle('mobile-facets-buttons--sticky', sticky);
        if (sticky) {
          buttons.style.top = headerBottom + 'px';
          buttons.style.left = rect.left + 'px';
          buttons.style.right = 'auto';
          buttons.style.width = rect.width + 'px';
          buttons.style.height = height + 'px';
          buttons.style.boxSizing = 'border-box';
        } else {
          ['top', 'left', 'right', 'width', 'height', 'box-sizing'].forEach(name => buttons.style.removeProperty(name));
        }
      }

      function scheduleUpdate() {
        if (!frame) frame = requestAnimationFrame(update);
      }

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('pageshow', measure);
      mobile.addEventListener('change', measure);
      if (header) new ResizeObserver(measure).observe(header);
      measure();
    }
  })();

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.fc-browse');
  const form = root?.querySelector('#FacetFiltersFormMobileNew');
  const grid = root?.querySelector('#ProductGridContainer');
  if (!form || !grid) return;
  const drawer = form.closest('[data-facets-drawer="filter"]');
  const chips = root.querySelector('.mobile-facets-chips-wrapper');
  const sortSelect = document.createElement('select');
  sortSelect.className = 'fitau-sort-select';
  sortSelect.setAttribute('aria-label', '商品の並び順');
  [['manual','おすすめ順'],['best-selling','人気順'],['price-ascending','価格の安い順'],['price-descending','価格の高い順']].forEach(([value,label]) => {
    const option = document.createElement('option');
    option.value = value; option.textContent = label; sortSelect.append(option);
  });
  sortSelect.value = new URL(location.href).searchParams.get('sort_by') || 'manual';
  if (!sortSelect.value) sortSelect.value = 'manual';
  const sortGroup = document.createElement('label');
  sortGroup.className = 'fitau-filter-sort';
  const sortLabel = document.createElement('span');
  sortLabel.textContent = '並び順';
  sortGroup.append(sortLabel, sortSelect);
  const footer = form.querySelector('.mobile-facets-drawer__footer');
  if (footer) footer.before(sortGroup);
  else form.append(sortGroup);
  drawer.querySelector('[data-facets-close]')?.setAttribute('aria-label', '絞り込みを閉じる');
  root.classList.add('fitau-compact-sort');
  sortSelect.addEventListener('change', () => {
    const url = currentURL();
    url.searchParams.set('sort_by', sortSelect.value);
    url.searchParams.delete('page');
    update(url);
  });
  const status = document.createElement('div');
  status.className = 'fitau-filter-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  form.prepend(status);
  const apply = form.querySelector('[data-facets-apply]');
  if (apply) apply.textContent = '商品を見る';
  root.classList.add('fitau-live-filters');
  let controller, timer, revision = 0;
  function currentURL() {
    const url = new URL(location.href);
    [...url.searchParams.keys()].forEach(k => {
      if (k.startsWith('filter.') || k === 'page') url.searchParams.delete(k);
    });
    for (const [key, value] of new FormData(form)) {
      if (!value) continue;
      if (key === 'sort_by') url.searchParams.set(key, value);
      else url.searchParams.append(key, value);
    }
    url.searchParams.set('sort_by', sortSelect.value);
    return url;
  }
  async function update(url, push = true) {
    clearTimeout(timer);
    const version = ++revision;
    controller?.abort();
    controller = new AbortController();
    grid.setAttribute('aria-busy', 'true');
    status.textContent = '商品を更新しています…';
    const request = new URL(url);
    request.searchParams.set('section_id', grid.dataset.id);
    try {
      const response = await fetch(request, { signal: controller.signal });
      if (!response.ok) throw new Error('response');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = html.querySelector('#ProductGridContainer');
      if (!nextGrid) throw new Error('grid');
      if (version !== revision) return;
      grid.innerHTML = nextGrid.innerHTML;
      grid.querySelectorAll('.scroll-trigger').forEach(e => e.classList.add('scroll-trigger--cancel'));
      const nextChips = html.querySelector('.mobile-facets-chips-wrapper');
      if (nextChips) chips.innerHTML = nextChips.innerHTML;
      const count = root.querySelector('.mobile-facets-count');
      const nextCount = html.querySelector('.mobile-facets-count');
      if (count && nextCount) count.innerHTML = nextCount.innerHTML;
      const nextResultCount = html.querySelector('.fitau-filter-result-count');
      if (nextResultCount) root.querySelectorAll('.fitau-filter-result-count').forEach(el => { el.textContent = nextResultCount.textContent; });
      form.querySelectorAll('input').forEach(input => {
        const next = Array.from(html.querySelectorAll('#FacetFiltersFormMobileNew input')).find(e => e.name === input.name && (input.type === 'number' || e.value === input.value));
        if (!next) return;
        input.checked = next.checked;
        input.disabled = next.disabled;
        if (input.type === 'number') input.value = next.value;
        const label = input.closest('.mobile-facets-checkbox');
        label?.classList.toggle('active', input.checked);
        label?.classList.toggle('disabled', input.disabled);
      });
      sortSelect.value = url.searchParams.get('sort_by') || 'manual';
      form.querySelectorAll('input[name="sort_by"]').forEach(input => { input.value = sortSelect.value; });
      if (push) history.pushState({ searchParams: url.searchParams.toString() }, '', url);
      status.textContent = nextCount ? nextCount.textContent.trim() + 'を表示しています' : '更新しました';
    } catch (error) {
      if (error.name !== 'AbortError' && version === revision) {
        status.textContent = '更新できませんでした。';
        const retry = document.createElement('a');
        retry.href = url.href;
        retry.textContent = '再読み込みする';
        status.append(retry);
      }
    } finally {
      if (version === revision) grid.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('change', event => {
    if (!form.contains(event.target) || !event.target.matches('input')) return;
    event.stopImmediatePropagation();
    event.target.closest('.mobile-facets-checkbox')?.classList.toggle('active', event.target.checked);
    controller?.abort();
    revision++;
    clearTimeout(timer);
    timer = setTimeout(() => update(currentURL()), 180);
  }, true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('.mobile-facets-chip__link, .mobile-facets-drawer__clear-link');
    if (remove && root.contains(remove)) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (remove.matches('.mobile-facets-drawer__clear-link')) {
        form.querySelectorAll('input[type="checkbox"]').forEach(e => {e.checked = false;});
        form.querySelectorAll('input[type="number"]').forEach(e => {e.value = '';});
        update(currentURL());
       } else {
        const url = new URL(remove.href);
        const name = remove.dataset.filterName;
        if (name) {
          const values = url.searchParams.getAll(name).filter(value =>
            value !== remove.dataset.filterValue && value !== remove.dataset.filterLabel
          );
          url.searchParams.delete(name);
          values.forEach(value => url.searchParams.append(name, value));
        }
        url.searchParams.delete('page');
        update(url);
      }
      return;
    }
    if (apply && apply.contains(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation();
      drawer.classList.remove('active');
      root.querySelector('[data-facets-overlay]')?.classList.remove('active');
      document.body.style.overflow = '';
    }
  }, true);
  window.addEventListener('popstate', event => {
    event.stopImmediatePropagation();
    update(new URL(location.href), false);
  }, true);
});



